/**
 * What the next import would do with a slot, in the order the summary and the status tag groups list them. Each entry
 * names the action as the payload does, and pairs it with:
 *   - `color`:     the `sp-chip` color role its status tags take
 *   - `icon`:      the `sp-icon` its status tags lead with
 *   - `copy`:      the suffix of its copy keys: `total_*` (a stat card), `result_*` (a tag with a count),
 *                  `action_*` (a slot's tag)
 */
export const ACTIONS = Object.freeze([
  Object.freeze({ key: "create", color: "info", icon: "info-filled", copy: "create" }),
  Object.freeze({ key: "keepActive", color: "success", icon: "check-filled", copy: "keep_active" }),
  Object.freeze({ key: "deactivate", color: "warning", icon: "warning-filled", copy: "deactivate" }),
  Object.freeze({ key: "reject", color: "danger", icon: "important-filled", copy: "reject" }),
]);

/**
 * The `ACTIONS` entries keyed by the payload's name for each action.
 */
export const ACTIONS_BY_KEY = Object.freeze(Object.fromEntries(ACTIONS.map((action) => [action.key, action])));
